export default __webpack_public_path__ + "static/media/4.f18b2ea4.png";